const asBaseURL = (value: unknown): string => (typeof value === 'string' ? value : '')

/**
 * SSR 在容器内直连内网网关以绕开公网 WAF；浏览器只能解析公网域名。
 * 构建期预渲染（import.meta.prerender）强制走公网，避免 CI 访问不到内网。
 */
export function resolveApiBaseURL(publicBase?: unknown, internalBase?: unknown): string | undefined {
  const internal = asBaseURL(internalBase)
  const isPrerender = import.meta.prerender === true
  if (import.meta.server && internal && !isPrerender) {
    return internal
  }
  return asBaseURL(publicBase) || undefined
}
